import { Button } from 'app/components/common/Button';
import { Icon } from 'app/components/common/Icon';
import { notify } from 'app/components/common/notify';
import { useStore } from 'app/context';
import { observer } from 'mobx-react';
import { AudioTranscriptionModal } from 'app/components/documents/AudioTranscriptionModal';

/**
 * Admin-only smoke test for the transcription infrastructure. Unlike the regular
 * recording buttons, this intentionally ignores `Config.enableTranscriptions` so
 * the backend (transcription service / Whisper) can be verified on production.
 */
export const AdminTestTranscription = observer(() => {
	const { uiStore } = useStore();
	const modalId = uiStore.modalIds.audioRecordingTest;

	const onOpen = () => {
		uiStore.showModal(modalId);
	};

	const onDone = (text: string) => {
		notify('Transkription erfolgreich', text ? text : '(kein Text erkannt)', 'success');
	};

	return (
		<>
			<div className="content">
				<h3>Transkription testen</h3>
				<p>
					Nimm eine kurze Sprachnotiz auf, um die Transkriptions-Infrastruktur zu testen. <br />
					Dieser Test ignoriert das <strong>enableTranscriptions</strong> Feature-Flag.
				</p>
			</div>

			<Button className="button is-primary is-inverted is-small" type="button" onClick={onOpen}>
				<Icon iconClass="microphone" /> Transkription testen
			</Button>

			<AudioTranscriptionModal modalId={modalId} title="Transkription testen" doneLabel="OK" onDone={onDone} />
		</>
	);
});
